import React from 'react';
import { compose } from 'redux';

import __DEPRECATED_defineResources from 'dpl/shared/fetching/deprecated/defineResources';
import { CONSTRAINT_TYPES } from 'dpl/shared/validations/constraints';
import withFormCapabilities from 'dpl/form/decorators/withFormCapabilities';
import UserAuthInviteForm from 'dpl/UserAuth/components/UserAuthInviteForm';
import { userInviteResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';

function UserAuthInviteFormContainer(props) {
  return <UserAuthInviteForm {...props} />;
}

export default compose(
  __DEPRECATED_defineResources((state, props) => ({
    sessionData: userInviteResourceDefinition(
      props.match.params.userId,
      props.match.params.inviteToken
    )
  })),
  withFormCapabilities(() => ({}), {
    onSubmit: (props, formStateForSubmission) =>
      props.sessionData.submit(formStateForSubmission),
    mapPropsAndStateToValidationSchema: () => ({
      password: CONSTRAINT_TYPES.PASSWORD,
      password_confirmation: {
        presence: true,
        equality: {
          attribute: 'password',
          message: "Passwords don't match"
        }
      }
    })
  })
)(UserAuthInviteFormContainer);
